import { supabase } from "@/integrations/supabase/client";

export type AdminAuditEvent = "login" | "role_check" | "route_visit" | "access_denied";

interface LogParams {
  userId: string;
  email?: string | null;
  eventType: AdminAuditEvent;
  route?: string | null;
  roleGranted?: boolean | null;
  metadata?: Record<string, unknown>;
}

/**
 * Fire-and-forget audit log via a SECURITY DEFINER RPC. The server function
 * recomputes `role_granted` from the caller's id, so clients can't forge it.
 * Failures are swallowed — the audit log must never break the user flow.
 */
export async function logAdminAccess({
  userId: _userId,
  email,
  eventType,
  route,
  roleGranted,
  metadata,
}: LogParams): Promise<void> {
  try {
    await supabase.rpc("log_admin_access" as never, {
      _event_type: eventType,
      _route: route ?? null,
      _role_granted: roleGranted ?? null,
      _user_email: email ?? null,
      _metadata: {
        ...(metadata ?? {}),
        user_agent:
          typeof navigator !== "undefined" ? navigator.userAgent : null,
      },
    } as never);
  } catch {
    /* never throw from audit logger */
  }
}
